import FormElementMixin from '../mixins/FormElementMixin.js';
import codemirror from 'codemirror';

Vue.asyncComponent('ak-wysiwyg', {
    mixins: [FormElementMixin],
    props: {
        configOptions: {
            type: Object|Array,
            required: true
        },
    },
    watch: {
        value(newValue, oldValue) {
            // if we have a new value
            if(! this.$deepEqual(newValue,oldValue)) {
                // update redactor
                this.$refs.redactor.redactorx.app.editor.setContent({ html: this.currentValue});
            }
        },
        activeLocale() {
            this.$refs.redactor.redactorx.destroy();
        }
    },
    computed: {
        activeLocale() {
            return this.$localeHandler.getActiveLocale();
        },
        currentConfigOptions() {
            const csrfToken = this.$getSetting('security.csrfToken');

            return {
                ...this.configOptions,
                image: {
                    ...this.configOptions.image,
                    upload: this.$getSetting('paths.baseAppKit') + this.configOptions.image.upload
                },
                editor: {
                    lang: 'nl',
                    ...this.configOptions.editor,
                },
                clean: true,
                codemirrorSrc: codemirror,
                codemirror: {
                    lineWrapping: true,
                    lineNumbers: true,
                    theme: this.darkModeActive ? 'material-ocean' : 'default',
                    mode: 'text/html',
                    readOnly: this.readOnly,
                    matchBrackets: true,
                    autoCloseBrackets: true,
                    autoCloseTags: true,
                    matchTags: {
                        bothTags: true
                    }
                },
                placeholder: this.placeholder,
                subscribe: {
                    'editor.focus': this.focus,
                    'editor.blur': (event) => {
                        const editor = this.$refs.redactor.redactorx.editor;

                        let content = editor.getContent();

                        if (content === '<p><br></p>') {
                            editor.setEmpty(); // Clear content
                        }
                        this.blur(event);
                    },
                    'app.start': (event) => {
                        // make sure Firefox don't focus the toolbar
                        this.$el.querySelectorAll('.rx-toolbar').forEach(btn => {
                            btn.setAttribute('tabindex', '-1');
                        });
                    },
                    'upload.before.send': (event) => {
                        event.params.xhr.setRequestHeader('X-CSRF-Token', csrfToken);
                    },
                    'editor.keydown': (event) => {
                        this.$emit('keydown', event.params.e);
                    },
                    // fix for bug where we save the value in codeEditor the changes won't come true
                    'source.change': (event) => {
                        this.currentValue = event.params.e.getValue();
                    },
                    ...this.$currentListeners
                }
            }
        },
        /**
         * Check if we are in dark mode
         * @returns {boolean|null|watch.darkMode|*}
         */
        darkModeActive() {
            if (! this.$darkModeHandler) {
                return false;
            }

            return this.$darkModeHandler.darkMode;
        }
    }
}, 'form/controls/ak-wysiwyg.html');
